import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_DIGITAL_SIGNAGE = ROUTE_PATH_ADMIN + '/digital-signage';
